<template>
  <div>
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <h1 id="headline" class="page-header">Access Rules</h1>
      <div class="d-flex align-items-center my-2">
        <div>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <font-awesome-icon icon="search"/>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input v-model="accessRulesFilter" debounce="500" placeholder="Filter" type="text"></b-form-input>
          </b-input-group>
        </div>
        <b-button @click="showAddAccessRuleModal" variant="outline-dark" class="ml-3">
          <font-awesome-icon icon="plus"/>
          <span class="ml-2 d-none d-sm-inline">Add Access Rules</span>
        </b-button>
      </div>
    </div>

    <b-table :items="accessRules" :fields="fields" small striped :filter="accessRulesFilter">
      <template #cell(affected_machines_count)="data">
        <span v-if="data.value > 0">
          <a href="#" @click="showAffectedMachineModal(data.item.affected_machines, data.item.email, data.item.rule_type)">
            {{ data.value }} machine{{ data.value > 1 ? 's' : '' }}
          </a>
        </span>
        <span v-else>
          0 machines
        </span>
      </template>
      <template #cell(actions)="data">
        <div class="float-right">
          <b-dropdown right variant="link" size="sm" no-caret class="ml-2">
            <template #button-content>
              <font-awesome-icon icon="ellipsis-v"/>
            </template>
            <b-dropdown-item @click="showEditAccessRuleModal(data.item)">
              Edit
            </b-dropdown-item>
            <b-dropdown-item @click="showDeleteAccessRuleModal(data.item, data.item.email, data.item.rule_type)">
              Delete
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <!-- Modals -->
    <access-rules-modal-delete ref="AccessRulesModalDelete"></access-rules-modal-delete>
    <access-rules-modal-add ref="AccessRulesModalAdd"></access-rules-modal-add>
    <access-rules-modal-edit ref="AccessRulesModalEdit"></access-rules-modal-edit>
    <access-rules-modal-affected-machines ref="AccessRulesModalAffectedMachines"></access-rules-modal-affected-machines>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import AccessRulesModalAffectedMachines from '@/components/access_rules/AccessRulesModalAffectedMachines.vue'
import AccessRulesModalDelete from '@/components/access_rules/AccessRulesModalDelete.vue'
import AccessRulesModalAdd from '@/components/access_rules/AccessRulesModalAdd.vue'
import AccessRulesModalEdit from '@/components/access_rules/AccessRulesModalEdit.vue'

export default {
  name: 'AccessRulesPage',
  components: { AccessRulesModalAffectedMachines, AccessRulesModalDelete, AccessRulesModalAdd, AccessRulesModalEdit },
  data () {
    return {
      accessRulesFilter: '',
      selectedAccessRule: null,
      fields: [
        { 'key': 'email', 'label': 'Email', 'sortable': true },
        { 'key': 'rule_type', 'label': 'Rule Type', 'sortable': true },
        { 'key': 'affected_machines_count', 'label': 'Affected', 'sortable': true },
        { 'key': 'actions', 'label': 'Actions' },
      ],
    }
  },
  created () {
    this.$store.dispatch('loadAccessRules')
  },
  computed: {
    ...mapGetters(['getAccessRules']),
    accessRules () {
      return this.getAccessRules.map(accessRule => {
        return {
          ...accessRule,
          affected_machines_count: accessRule.affected_machines.length
        }
      })
    }
  },
  methods: {
    showAffectedMachineModal (affectedMachines, email, ruleType) {
      this.$refs['AccessRulesModalAffectedMachines'].show(affectedMachines, email, ruleType)
    },
    showDeleteAccessRuleModal (accessRulesGroup, email, ruleType) {
      this.$refs['AccessRulesModalDelete'].show(accessRulesGroup, email, ruleType)
    },
    showAddAccessRuleModal () {
      this.$refs['AccessRulesModalAdd'].show()
    },
    showEditAccessRuleModal (accessRulesGroup) {
      this.$refs['AccessRulesModalEdit'].show(accessRulesGroup)
    },
  }
}
</script>

<style lang="scss">
</style>
